(ns hai.ui.components.click-outside
  (:require
   ["react" :as react]))

(defn on-click-out
  "React hook: runs `on-outside` on any document click landing outside the
   node in `ref` — unless a handler inside already called `preventDefault` on
   it (React's `stopPropagation` can't stop this native document-level
   listener, but the shared native event's `defaultPrevented` flag is readable
   here — treat it as \"handled inside\", not an outside click). The handler
   is captured at mount, so it must read live state through atoms/refs, not
   closed-over values."
  [ref on-outside]
  (let [handler (fn [event]
                  (assert (.-current ref))
                  (let [dom-node (first (.. event composedPath))]
                    (when (and (not (.-defaultPrevented event))
                               (not (.contains (.-current ref) dom-node)))
                      (on-outside))))]
    (react/useEffect
     (fn []
       (-> (.-body js/document)
           (.addEventListener "click" handler))
       (fn []
         (some-> (.-body js/document)
                 (.removeEventListener "click" handler))))
     #js [])))

(defn- area*
  [{on-outside :on-click-out :as props} & children]
  (let [ref (react/useRef nil)]
    (on-click-out ref on-outside)
    (into [:div (-> props (dissoc :on-click-out) (assoc :ref ref))]
          children)))

(defn area
  "Wraps `children` in a div that calls the `:on-click-out` prop on any click
   outside it; every other prop lands on the div. Mount-capture caveat as per
   [[on-click-out]]."
  [props & children]
  (into [:f> area* props] children))
